module.exports = __WEBPACK_EXTERNAL_MODULE_85__;


//////////////////
// WEBPACK FOOTER
// external {"root":["Rx"],"commonjs":"rxjs/operator/switchMap","commonjs2":"rxjs/operator/switchMap","amd":"rxjs/operator/switchMap"}
// module id = 85
// module chunks = 0